<template>
  <div class="success-msg">
    <span class="success-msg__icon" :class="{ 'icon-error': !isSuccess }">
      <img
        v-if="isSuccess"
        src="../../../../../assets/success_email_icon.svg"
        alt="Email Success Icon"
      />
      <img
        v-else
        src="../../../../../assets/failure_email_icon.svg"
        alt="Email Failure Icon"
      />
    </span>
    <p class="success-msg__title">
      {{ isSuccess ? 'Sent!' : 'Message not delivered' }}
    </p>
    <p class="success-msg__subtitle">
      <template v-if="isSuccess">
        Your message to {{ recipient }} has been sent succesfully.
      </template>
      <template v-else>
        We're sorry but there was a problem delivering your message to {{ recipient }}. Please wait a few minutes and try again.
      </template>
    </p>
  </div>
</template>

<script>
export default {
  name: 'ModalContentDialog.vue',
  props: {
    isSuccess: Boolean,
    recipient: String
  }
};
</script>

<style lang="scss" scoped>
$primary-dark: #333333;
$info-color: #f3fbfb;
$error-color: #FAEAED;

.success-msg {
  align-self: center;
  flex: 1;
  width: 60%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &__icon {
    width: 48px;
    height: 48px;
    background-color: $info-color;
    border-radius: 50%;

    &.icon-error {
      background-color: $error-color;
    }

    & img {
      width: 20px;
      height: 14px;
      margin-left: 14px;
      margin-top: 17px;
    }
  }

  &__title {
    margin-top: 8px;

    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;

    text-align: center;
    letter-spacing: 0.8px;

    color: $primary-dark;
  }

  &__subtitle {
    margin-top: 8px;

    font-style: normal;
    font-weight: 450;
    font-size: 14px;
    line-height: 20px;

    text-align: center;
    letter-spacing: 0.4px;

    max-width: 280px;
    word-break: normal;

    color: $primary-dark;
  }
}
</style>
